module.exports = __webpack_public_path__ + "static/media/city.16ce42bd.png";